export default "__VITE_ASSET__Co$3jq8F__"